import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { FilterModalDatePicker } from './filterModalDatePicker.component';
import { FiltersActions, selectCurrentFilter } from '../../../../modules/filters';
import { selectMarketsWithRegions } from '../../../../modules/market';

const mapStateToProps = createStructuredSelector({
  currentFilter: selectCurrentFilter,
  locationData: selectMarketsWithRegions,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setFilterDataByFilterName: FiltersActions.setFilterDataByFilterName,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(FilterModalDatePicker);
